module.exports = __webpack_public_path__ + "img/panels_parallel01.93564634.gif";